import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class ScriptSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'script-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
